(function($){
    "use strict";

    $.OverlayWebGL = function () {
        this._component_name = 'webgl';
        this._events = {
            click: 'click',
            clear_selection: 'clear_selection',
            hover: 'hover', 
            ready: 'ready',
            overlay_added: 'overlay_added'
        };

        this._on_load_json_overlays = this._on_load_json_overlays.bind(this);
        this._overlay_clicked = this._overlay_clicked.bind(this);
        this._on_clear_selection = this._on_clear_selection.bind(this);

        this._on(this._events.click, this._overlay_clicked);
        this._on(this._events.clear_selection, this._on_clear_selection);
    };

    $.Component.create($.OverlayWebGL, /** @lends {ABDOMap.OverlayWebGL.prototype}*/{
        _create_arrow: function(pt_a, pt_b) {
            // idea from https://itecnote.com/tecnote/r-three-js-line-vector-to-cylinder/
            var direction = new THREE.Vector3().subVectors(pt_b, pt_a);
            var length = direction.length();
            var dir_normalized = direction.clone().divideScalar(length);

            var arrow = new THREE.ArrowHelper(dir_normalized, pt_a, length);
            
            var material = this._options.arrow_material.clone();
            var cylinder = new THREE.CylinderGeometry(0.0005, 0.0005, length, 32);
            var object = new THREE.Mesh(cylinder, material);
            var position = new THREE.Vector3().addVectors(pt_a, direction.multiplyScalar(0.5));
            object.rotation.setFromQuaternion(arrow.quaternion);
            object.position.set(position.x, position.y, position.z);

            return object;
        },

        _update_arrow: function(arrow, pt_a, pt_b) {
            // idea from https://itecnote.com/tecnote/r-three-js-line-vector-to-cylinder/
            var direction = new THREE.Vector3().subVectors(pt_b, pt_a);
            var length = direction.length();
            var dir_normalized = direction.clone().divideScalar(length);
            
            var arrow_helper = new THREE.ArrowHelper(dir_normalized, pt_a, length);
            var cylinder = new THREE.CylinderGeometry(0.0005, 0.0005, length, 32);
            var position = new THREE.Vector3().addVectors(pt_a, direction.multiplyScalar(0.5));
            arrow.geometry = cylinder;
            arrow.rotation.setFromQuaternion(arrow_helper.quaternion);
            arrow.position.set(position.x, position.y, position.z);

            arrow.updateMatrix();
        },

        _remove_arrow: function(viewer) { 
            var ogl = viewer.abdo.overlay_webgl;
            if (ogl.arrow) { 
                ogl.arrow.removeFromParent(); 
                ogl.arrow = null;
            }
        },

        _on_clear_selection: function () { 
            var i, viewer;
            for(i = 0; i < this.viewers.length; i++) {
                viewer = this.viewers[i];
                this._remove_arrow(viewer);
            }
        },
        
        _display_arrow: function(viewer, object) {
            var ogl = viewer.abdo.overlay_webgl;
            if (viewer.abdo.location_overlay) {
                var location = viewer.abdo.location_overlay.location;
                var pos = this.img_to_space(location.x, location.y, 1, 1);
                var from = new THREE.Vector3(pos.x, pos.y, 0);
                var to = object.position.clone(); 

                if (ogl.arrow) {
                    this._update_arrow(ogl.arrow, from, to); 
                }  
                else {
                    ogl.arrow = this._create_arrow(from, to);
                    this.scene.add(ogl.arrow);
                }

                var distance = viewer.abdo.localization.point_distance(from, to);

                // see if there is an existing CSS2Object in ogl.distance, if there's one remove only if its parent is another object
                // create CSS2DObject if necessary
                // add distance CSS2DObject as child of object
                // set position of CSS2DObject
                
            }
        },

        _overlay_clicked: function(object) {
            if (!this.viewers) {
                return;
            }

            var i, viewer;
            for(i = 0; i < this.viewers.length; i++) {
                viewer = this.viewers[i];
                this._display_arrow(viewer, object); 
            }
        },

        _init_: function(options) { 
            this._options = options || {};
            this._parent_options = this.parent._options || {};
            this.max_fps = options.max_fps || 40; 
            var osd = this.parent.parent; // hierarchy: osd <- overlay <- overlay_link
            this._tracker = osd.tracker || null; // hierarchy: osd -> tracker

            // if parent didnt activate webgl don't use it
            if (!this.parent.using_webgl) {
                return;
            } 

            this.viewers = [];
            if (Array.isArray(this.parent.viewers)) {
                this.viewers = this.parent.viewers;
            }

            if (this._parent_options.overlays) {
                ABDOUtil.getJSON(this._parent_options.overlays, this._on_load_json_overlays);
            }

            if (!this._options.scene) {
                this._options.scene = {
                    light_color: 0xffffff,
                    light_intensity: 0.5,
                    light_distance: 2,
                    light_z: 0
                };
            }

            if (!this._options.geometry) {
                this._options.geometry = new THREE.SphereGeometry(0.01, 32, 16);

                // this._options.geometry = new THREE.Sprite();
                // this._options.geometry.scale.set(0.01,0.01,0.01);
            }

            if (!this._options.material) {
                this._options.material =  new THREE.MeshPhongMaterial( { 
                        color: 0x00ff00, 
                        side: THREE.DoubleSide, 
                        flatShading: false, 
                        transparent: true, 
                        opacity: 0.1
                    });

                // this._options.material =  new THREE.SpriteMaterial( { 
                //     color: 0x00ff00,  
                //     transparent: true, 
                //     opacity: 0.25
                // });
            }   

            if (!this._options.arrow_material) {
                this._options.arrow_material =  new THREE.MeshPhongMaterial( { 
                        color: 0x0000ff,
                        side: THREE.DoubleSide, 
                        flatShading: false
                    });
 
            }   

            if (!this._options.beacon) {
                this._options.beacon = { 
                    edgeStrength: 1,
                    edgeGlow: 10,
                    edgeThickness: 5,
                    pulsePeriod: 3,
                    usePatternTexture: false,
                    visibleEdgeColor: '#00c100',
                    hiddenEdgeColor: '#00c100',  
                };
            }

            if (!this._options.outline) {
                this._options.outline = { 
                    edgeStrength: 3,
                    edgeGlow: 0,
                    edgeThickness: 1,
                    pulsePeriod: 0,
                    usePatternTexture: false,
                    visibleEdgeColor: '#000000',
                    hiddenEdgeColor: '#000000',  
                };
            }  

            if (this._options.debug === true) {
                this.debug = true;
            }
            else {
                this.debug = false;
            }

            this._on_finished_tracking = this._on_finished_tracking.bind(this);
            this._reset_link = this._reset_link.bind(this);

            this._tracker._on(this._tracker._events.finished_tracking, this._on_finished_tracking);
            this._tracker._on(this._tracker._events.reset_tracking, this._reset_link);
 
            $.Component.call(this, $.OverlayWebGL);   
        }, 

        _on_finished_tracking: function() {
            var i, viewer;
            for(i = 0; i < this.viewers.length; i++) {
                viewer = this.viewers[i];
                var ogl = viewer.abdo.overlay_webgl;
                if (ogl.selected_objects.length > 0) {
                    this._display_arrow(viewer, ogl.selected_objects[0]);
                }
            }
        },
        
        _reset_link: function(){

        },
        _on_load_json_overlays: function(overlays) {
            this.overlays = overlays;
            this._init_webgl();
            this.objects = [];
            if (Array.isArray(this.overlays) && this.overlays.length > 0) {
                
                for(var overlay of this.overlays) {
                    this._add_overlay(overlay);
                } 
            }
        },

        _add_overlay: function(overlay) {  
            var i, viewer;
            
            for(i = 0; i < this.viewers.length; i++) {
                viewer = this.viewers[i];
                var abdo = viewer.abdo;
                var overlay_webgl = abdo.overlay_webgl; 
                
                // create object
                var geometry = this._options.geometry.clone();
                var material = this._options.material.clone();
                var object;
                if (geometry.type == "Sprite") {
                    object = geometry;
                }
                else { 
                    object = new THREE.Mesh( geometry, material );
                }   
                
                
                // set object position and overlay
                var pos = this.img_to_space(overlay.x, overlay.y, 1, 1);
                object.position.set(pos.x, pos.y);
                object.overlay = overlay;

                this.scene.add(object);

                if (Array.isArray(overlay_webgl.objects)) {
                    overlay_webgl.objects.push(object);
                }
                else {
                    overlay_webgl.objects = [object];
                }

                this._emit(this._events.overlay_added, viewer, overlay);
            }
        },

        _init_webgl: function() {
            var i, viewer, overlay_webgl;

            this.scene = new THREE.Scene();
            this.scene.background = null;

            for(i = 0; i < this.viewers.length; i++) {
                viewer = this.viewers[i]; 

                // setup viewer variables context
                viewer.abdo.overlay_webgl = {};
                overlay_webgl = viewer.abdo.overlay_webgl; 
                overlay_webgl.objects = [];
                overlay_webgl.selected_objects = [];
                overlay_webgl.bounds = viewer.viewport.getBoundsNoRotate();
                var bounds = overlay_webgl.bounds;

                var canvas_width = viewer.canvas.clientWidth;
                var canvas_height = viewer.canvas.clientHeight;  
                var aspect = canvas_width / canvas_height;  
                var osd_canvas = viewer.abdo.osd_canvas;

                // setup renderer
                overlay_webgl.renderer = new THREE.WebGLRenderer({ alpha: true });
                var renderer = overlay_webgl.renderer;
                renderer.autoClear = true;
                renderer.setSize(canvas_width, canvas_height); 
                renderer.setClearColor( 0x000000, 0 );
                viewer.abdo.layers.push(renderer.domElement); 

                // // setup labels renderer
                // overlay_webgl.label_renderer = new THREE.CSS2DRenderer();
                // var label_renderer = overlay_webgl.label_renderer;
                // label_renderer.setSize(canvas_width, canvas_height);
                // viewer.canvas.prepend(label_renderer.domElement);


                // setup lights
                var light_color = this._options.scene.light_color;
                var intensity = this._options.scene.light_intensity; 
                var distance = this._options.scene.light_distance;
                var light_z = this._options.scene.light_z;
                overlay_webgl.lights = [new THREE.PointLight( light_color, intensity, distance), 
                                        new THREE.PointLight( light_color, intensity, distance), 
                                        new THREE.PointLight( light_color, intensity, distance),
                                        new THREE.PointLight( light_color, intensity, distance),
                                        new THREE.PointLight( light_color, intensity, distance), 
                                        // new THREE.AmbientLight( light_color , intensity),
                                    ]; 
                
                // ambient + corners pointlight + center pointlight
                var light_z = 1;
                overlay_webgl.lights[0].position.set( 0  , 0  , light_z); 
                overlay_webgl.lights[1].position.set(-0.5, 0.5, light_z); 
                overlay_webgl.lights[2].position.set( 0.5, 0.5, light_z);
                overlay_webgl.lights[3].position.set( 0.5,-0.5, light_z);
                overlay_webgl.lights[4].position.set(-0.5,-0.5, light_z);   
                // overlay_webgl.lights[5].position.set(0, 0, light_z);
                
                // add created lights to scene
                for (const light of overlay_webgl.lights) {
                    this.scene.add(light);    
                } 
            
                overlay_webgl.camera = new THREE.OrthographicCamera(- aspect / 2, aspect / 2, 0.5, -0.5, -1, 1);
                var camera = overlay_webgl.camera;
                this.adjust_rendering_bounds(camera, renderer, bounds); 
                camera.zoom = 1; 
                camera.updateProjectionMatrix();  

                // setup postprocessing (effects)
                overlay_webgl.composer = new THREE.EffectComposer(renderer);
                var composer = overlay_webgl.composer;

                // render pass
                overlay_webgl.render_pass = new THREE.RenderPass(this.scene, camera);
                var render_pass = overlay_webgl.render_pass;
                composer.addPass(render_pass);

                // beacon pass
                overlay_webgl.beacon_pass = new THREE.OutlinePass(new THREE.Vector2(canvas_width, canvas_height), this.scene, camera);
                var beacon_pass = overlay_webgl.beacon_pass;
                beacon_pass.selectedObjects = [];
                beacon_pass.renderToScreen = true;  
                beacon_pass.edgeStrength = this._options.beacon.edgeStrength;
                beacon_pass.edgeGlow = this._options.beacon.edgeGlow;
                beacon_pass.edgeThickness = this._options.beacon.edgeThickness;
                beacon_pass.pulsePeriod = this._options.beacon.pulsePeriod;
                beacon_pass.usePatternTexture = this._options.beacon.usePatternTexture;
                beacon_pass.visibleEdgeColor.set(this._options.beacon.visibleEdgeColor);
                beacon_pass.hiddenEdgeColor.set(this._options.beacon.hiddenEdgeColor); 
                composer.addPass(beacon_pass);

                // outline pass
                overlay_webgl.outline_pass = new THREE.OutlinePass(new THREE.Vector2(canvas_width, canvas_height), this.scene, camera);
                var outline_pass = overlay_webgl.outline_pass;
                outline_pass.renderToScreen = true;
                outline_pass.selectedObjects = overlay_webgl.objects;
                outline_pass.edgeStrength = this._options.outline.edgeStrength;
                outline_pass.edgeGlow = this._options.outline.edgeGlow;
                outline_pass.edgeThickness = this._options.outline.edgeThickness;
                outline_pass.pulsePeriod = this._options.outline.pulsePeriod;
                outline_pass.usePatternTexture = this._options.outline.usePatternTexture;
                outline_pass.visibleEdgeColor.set(this._options.outline.visibleEdgeColor);
                outline_pass.hiddenEdgeColor.set(this._options.outline.hiddenEdgeColor); 
                composer.addPass(outline_pass); 

                
                // composer.addPass(label_renderer);
                

                if (this.debug && typeof(dat) !== "undefined") {
                    viewer.canvas.prepend(renderer.domElement);
                    overlay_webgl.gui = new dat.GUI();

                    var beacon_folder = overlay_webgl.gui.addFolder("Beacon");
                    beacon_folder.add(this._options.beacon, "edgeStrength", 0, 10).onChange(function(value) {
                        beacon_pass.edgeStrength = Number(value);
                    });
                    beacon_folder.add(this._options.beacon, "edgeGlow", 0, 10).onChange(function(value) {
                        beacon_pass.edgeGlow = Number(value);
                    });
                    beacon_folder.add(this._options.beacon, "edgeThickness", 0, 10).onChange(function(value) {
                        beacon_pass.edgeThickness = Number(value);
                    });
                    beacon_folder.add(this._options.beacon, "pulsePeriod", 0, 10).onChange(function(value) {
                        beacon_pass.pulsePeriod = Number(value);
                    });
                    beacon_folder.addColor(this._options.beacon, "visibleEdgeColor").onChange(function(value) {
                        beacon_pass.visibleEdgeColor.set(value);
                    }); 
                    beacon_folder.addColor(this._options.beacon, "hiddenEdgeColor").onChange(function(value) {
                        beacon_pass.hiddenEdgeColor.set(value);
                    }); 

                    beacon_folder.open();


                    var outline_folder = overlay_webgl.gui.addFolder("Outline");
                    outline_folder.add(this._options.outline, "edgeStrength", 0, 10).onChange(function(value) {
                        outline_pass.edgeStrength = Number(value);
                    });
                    outline_folder.add(this._options.outline, "edgeGlow", 0, 10).onChange(function(value) {
                        outline_pass.edgeGlow = Number(value);
                    });
                    outline_folder.add(this._options.outline, "edgeThickness", 0, 10).onChange(function(value) {
                        outline_pass.edgeThickness = Number(value);
                    });
                    outline_folder.add(this._options.outline, "pulsePeriod", 0, 10).onChange(function(value) {
                        outline_pass.pulsePeriod = Number(value);
                    });
                    outline_folder.addColor(this._options.outline, "visibleEdgeColor").onChange(function(value) {
                        outline_pass.visibleEdgeColor.set(value);
                    }); 
                    outline_folder.addColor(this._options.outline, "hiddenEdgeColor").onChange(function(value) {
                        outline_pass.hiddenEdgeColor.set(value);
                    }); 

                    outline_folder.open();

                    var lights_folder = overlay_webgl.gui.addFolder("Lights");
                    lights_folder.add({light_z: light_z}, "light_z", -5, 5 ).onChange(function(value) {
                        overlay_webgl.lights[0].position.set( 0  , 0  , value); 
                        overlay_webgl.lights[1].position.set(-0.5, 0.5, value); 
                        overlay_webgl.lights[2].position.set( 0.5, 0.5, value);
                        overlay_webgl.lights[3].position.set( 0.5,-0.5, value);
                        overlay_webgl.lights[4].position.set(-0.5,-0.5, value);   
                        // overlay_webgl.lights[5].position.set(0, 0, value);
                    });

                    lights_folder.open();


                    var link_folder = overlay_webgl.gui.addFolder("Link");
                    // link_folder.add(this._options.arrow_material, "linewidth", 0,50).onChange(function(value) {
                    //     self._options.arrow_material.set.set(value);
                    //     var i, viewer;
                    //     for(i = 0; i < self.viewers.length; i++) {
                    //         viewer = self.viewers[i];
                    //         var ogl = viewer.abdo.overlay_webgl;
                    //         if (ogl.arrow) {
                    //             ogl.arrow.line.material.linewidth = value;
                    //         }
                    //     }
                    // });

                    link_folder.addColor({color: "#000000"}, "color").onChange(function(value) {
                        self._options.arrow_material.color.set(value);
                        var i, viewer;
                        for(i = 0; i < self.viewers.length; i++) {
                            viewer = self.viewers[i];
                            var ogl = viewer.abdo.overlay_webgl;
                            if (ogl.arrow) {
                                ogl.arrow.line.material.color.set(value);
                            }
                        }
                    });
                    link_folder.open();
                }

                // initially set camera 
                this.adjust_rendering_bounds(camera, renderer, bounds);   
 

                // update renderer when windows is resized
                var self = this;
                viewer.addHandler("resize", function(evt) {  
                    var width = viewer.canvas.clientWidth;
                    var height = viewer.canvas.clientHeight; 
                    renderer.setSize(width, height);
                    label_renderer.setSize(width, height);
                    overlay_webgl.bounds = viewer.viewport.getBoundsNoRotate(); 
                    self.adjust_rendering_bounds(camera, renderer, overlay_webgl.bounds);  
                    composer.render( self.scene, overlay_webgl.camera );  
                }); 
                
                
                 // redraw when OpenSeadragon canvas is redrawn
                 viewer.addHandler("viewport-change", function(evt) {
                    overlay_webgl.bounds = viewer.viewport.getBoundsNoRotate();
                   
                    self.adjust_rendering_bounds(camera, renderer, overlay_webgl.bounds);     
                });
 
                // redraw when OpenSeadragon canvas is redrawn
                viewer.addHandler("update-viewport", function(evt) {
                    composer.render( self.scene, camera ); 
                });

                
                overlay_webgl.pointer = new THREE.Vector2(); 
                overlay_webgl.raycaster = new THREE.Raycaster(); 
                overlay_webgl.intersected = null;

                overlay_webgl.events_div = document.createElement("div");
                var events_div = overlay_webgl.events_div;
                events_div.style.width = "100%";
                events_div.style.height = "100%";
                events_div.style.position = "absolute";

                if (this.debug) {
                    viewer.canvas.prepend(events_div); 
                }
                else {
                    viewer.canvas.appendChild(events_div);
                }
                
                viewer.addHandler("rotate", function(event){
                    var radians = event.degrees / 180 * Math.PI;
                    camera.rotation.z = radians;
                });

                if (!ABDOUtil.hasTouchScreen) {
                    events_div.addEventListener("pointermove", function(event) { 
                        self._normalize_pointer_coordinates.call(self, event, viewer, overlay_webgl.pointer); 
                        self.intersected = self._estimate_intersected.call(self, overlay_webgl);
                        if (self.intersected && typeof(self.intersected.overlay) !== "undefined") {
                            events_div.style.cursor = "pointer";
                            self._on(self._events.hover, self.intersected);
                        }
                        else {
                            self.intersected = null;
                            events_div.style.cursor = "";
                        } 
                        
                    }, true);
                } 

                events_div.addEventListener(ABDOUtil.getClickHandler(osd_canvas), function(event) {  
                    self._normalize_pointer_coordinates.call(self, event, viewer, overlay_webgl.pointer);  

                    self.intersected = self._estimate_intersected.call(self, overlay_webgl);
                    if (self.intersected && typeof(self.intersected.overlay) !== "undefined") {
                        overlay_webgl.selected_objects = [self.intersected];
                        overlay_webgl.beacon_pass.selectedObjects = overlay_webgl.selected_objects;
                        viewer.raiseEvent("update-viewport"); 
                        self._emit(self._events.click, self.intersected);
                        event.stopImmediatePropagation();
                        return false;
                    }
                    else {
                        self._emit(self._events.clear_selection); 
                        overlay_webgl.selected_objects = [];
                        overlay_webgl.beacon_pass.selectedObjects = overlay_webgl.selected_objects;
                    } 
                }, true);


                // var clock = new THREE.Clock();
                // var delta_sum = 0;
                // var delta = 0;
                // var frame_count = 0;
                // delta_sum += delta;
                // window.avgs = [];
                function animate() { 
                    
                    // delta = clock.getDelta();
                    // delta_sum += delta;
                    // frame_count++;
                    // if (frame_count % 500 == 0) {
                    //     window.avgs.push(delta_sum / frame_count);
                    //     ABDOUtil.display_message("animation has taken an average of " + delta_sum / frame_count + " seconds");
                    // }
                    // ABDOUtil.display_message("outline objects: " + overlay_webgl.outline_pass.selectedObjects.length );
                    // if (delta <= 1/self.max_fps) { 
                        // object.rotation.x += 0.01;
                        // object.rotation.y += 0.01; 

                        // do the same as drawWorld from viewer.js 
                        viewer.imageLoader.clear();
                        viewer.drawer.clear();
                        viewer.world.draw();
                        viewer.raiseEvent("update-viewport");
                        // composer.render( self.scene, camera );  
                    // }
                    
                    requestAnimationFrame( animate );
                };
    
                requestAnimationFrame(animate);
            }
        },

        _normalize_pointer_coordinates: function(event, viewer, pointer) {
            var clientx = event.clientX;
            var clienty = event.clientY;

            if (event.type === "touchstart" || event.type === "touchend") {
                if (event.touches.length > 0) {
                    clientx = event.touches[0].clientX;
                    clienty = event.touches[0].clientY; 
                }
                else if (event.changedTouches.length > 0) {
                    clientx = event.changedTouches[0].clientX;
                    clienty = event.changedTouches[0].clientY; 
                }
            } 
            

            var element_rect = event.currentTarget.getBoundingClientRect(); 
            pointer.x =  ( (clientx - element_rect.left) / viewer.canvas.clientWidth ) * 2 - 1;
            pointer.y = -( (clienty - element_rect.top ) / viewer.canvas.clientHeight) * 2 + 1; 
        },

        _estimate_intersected: function(overlay_webgl) {
            overlay_webgl.raycaster.setFromCamera(overlay_webgl.pointer, overlay_webgl.camera);
            var intersects = overlay_webgl.raycaster.intersectObjects(this.scene.children);
            var intersected = null;

            if (intersects.length > 0) {
                intersected = intersects[0].object;
            } 

            return intersected;
        },

        adjust_rendering_bounds(camera, renderer, bounds, z) {
            if (typeof(z) === "undefined") {
                z = 0.0;
            }

            renderer.setScissor(bounds.x, bounds.y, bounds.width, bounds.height);
            var x = bounds.x + bounds.width/2;
            var y = bounds.y + bounds.height/2;
            var new_center = this.img_to_space(x, y, 1, 1);
            camera.position.x = new_center.x;
            camera.position.y = new_center.y;
            camera.position.z = z;
            camera.left   = -bounds.width /2;
            camera.right  =  bounds.width /2;
            camera.top    =  bounds.height/2;
            camera.bottom = -bounds.height/2;
            camera.updateProjectionMatrix();
        },

        img_to_space: function(x, y, width, height) { return { x: x - width/2, y: height/2 - y }},
        space_to_img: function(x, y, width, height) { return { x: x + width/2, y: height/2 - y }},

        get_object_size_ortho: function (object, camera, width, height) {
            // from https://stackoverflow.com/questions/27409074/converting-3d-position-to-2d-screen-position-r69/27410603#27410603
            if (!object.geometry.boundingSphere) {
                object.geometry.computeBoundingSphere();
            }

            var vector = new THREE.Vector3();
            var vector_delta = new THREE.Vector3();
            var widthHalf = 0.5*width;
            var heightHalf = 0.5*height;

            object.updateMatrixWorld();
            vector.setFromMatrixPosition(object.matrixWorld);

            vector_delta.x = vector.x + object.geometry.boundingSphere.radius;
            vector_delta.y = vector.y + object.geometry.boundingSphere.radius;
            vector_delta.z = vector.z + object.geometry.boundingSphere.radius;

            vector.project(camera);
            vector_delta.project(camera);

            vector.x = ( vector.x * widthHalf ) + widthHalf;
            vector.y = - ( vector.y * heightHalf ) + heightHalf;

            vector_delta.x = ( vector_delta.x * widthHalf ) + widthHalf;
            vector_delta.y = - ( vector_delta.y * heightHalf ) + heightHalf;


            return { 
                x: vector_delta.x - vector.x,
                y: vector_delta.y - vector.y
            };
        },

        _pointDistance: function(viewer, point_a, point_b) {
            var abdo = viewer.abdo;
            if (abdo && typeof(abdo.localization) !== "undefined") {
                var lonlat_a = abdo.localization.vp2lonlat(point_a.x, point_a.y);
                var lonlat_b = abdo.localization.vp2lonlat(point_b.x, point_b.y);
                
                return abdo.localization.geodesic_distance(lonlat_a[1], lonlat_a[0], lonlat_b[1], lonlat_b[0]);
            }
            
            return null;
        },

    }, $.Overlay); 

})(ABDOMap);